import { useState } from 'react';
import { useToast } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';

type CopiedValue = string | null;
type CopyFn = (text: string) => Promise<boolean>;

export function useCopyToClipboard(): { copy: CopyFn } {
  const { toastManager } = useToast();
  const { t } = useTranslation();

  const [, setCopiedText] = useState<CopiedValue>(null);

  const copy: CopyFn = async (text) => {
    if (!navigator?.clipboard) {
      return false;
    }

    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      toastManager({
        type: 'success',
        message: t('Copied value'),
        duration: 3000,
        testId: 'copied-value',
      });
      return true;
    } catch (error) {
      setCopiedText(null);
      return false;
    }
  };

  return { copy };
}
